import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StickyGeneralMessageContainer = styled.div<{ $isSticky: boolean; $top: number }>`
  @keyframes slideIn {
    from {
      transform: translateY(-100%);
    }
    to {
      transform: translateY(0);
    }
  }

  position: ${({ $isSticky }) => ($isSticky ? 'fixed' : 'relative')};
  top: ${({ $isSticky, $top }) => ($isSticky ? toRem($top) : 'auto')};
  left: ${({ $isSticky }) => ($isSticky ? '0' : 'auto')};
  width: ${({ $isSticky }) => ($isSticky ? '100%' : 'auto')};
  z-index: ${({ $isSticky }) => ($isSticky ? 9999 : 'auto')};
`;

export const StickyGeneralMessagePlaceholder = styled.div<{ $height: number }>`
  height: ${({ $height }) => toRem($height)};
`;
